/*
  Yurls Shop — aanbiedingenbanner.

  Het schuiven zelf doet de browser: de strook is een scrollbalk met
  snappunten, dus vegen op een telefoon werkt zonder een regel javascript.
  Dit bestand doet twee dingen die de browser niet vanzelf doet.

  1. Een klik op een pil laat de strook naar het bijbehorende paneel scrollen.
  2. De pillen van het paneel dat je niet ziet uit de tabvolgorde halen. Elk
     paneel heeft namelijk dezelfde twee pillen; zonder dit zou je met de
     tabtoets langs vier knoppen lopen waarvan er twee onzichtbaar zijn.

  Werkt javascript niet, dan zie je het eerste paneel en kun je nog steeds
  zijwaarts scrollen naar het tweede. Alleen de pillen doen dan niets.
*/

class YurlsOffer extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector('.y-offer__viewport');
    this.slides = Array.from(this.querySelectorAll('.y-offer__slide'));
    if (!this.viewport || this.slides.length < 2) return;

    this.huidig = 0;

    this.addEventListener('click', this.opKlik);
    this.viewport.addEventListener('scroll', this.opScroll, { passive: true });
    window.addEventListener('resize', this.opScroll);

    this.markeer(0);
  }

  disconnectedCallback() {
    this.viewport.removeEventListener('scroll', this.opScroll);
    window.removeEventListener('resize', this.opScroll);
  }

  opKlik = (event) => {
    const knop = event.target.closest('[data-goto]');
    if (!knop) return;

    const doel = Number(knop.dataset.goto);
    if (Number.isNaN(doel) || !this.slides[doel]) return;

    /*
      Eerst de aandacht verplaatsen naar de pil van het paneel waar we
      heengaan, pas daarna scrollen. Andersom zou de knop waar je net op
      staat halverwege uit de tabvolgorde worden gehaald, en dan raakt een
      toetsenbordgebruiker zijn plek kwijt.

      preventScroll voorkomt dat de browser er zelf al ruw heen springt; het
      soepele scrollen hieronder doet dat mooier.
    */
    const nieuwePil = this.slides[doel].querySelector('.y-offer__pill');
    if (nieuwePil && document.activeElement && document.activeElement.closest('.y-offer__pill')) {
      nieuwePil.focus({ preventScroll: true });
    }

    this.viewport.scrollTo({ left: this.viewport.clientWidth * doel, behavior: 'smooth' });
    this.markeer(doel);
  };

  opScroll = () => {
    const breedte = this.viewport.clientWidth;
    if (!breedte) return;

    const zichtbaar = Math.round(this.viewport.scrollLeft / breedte);
    if (zichtbaar !== this.huidig) this.markeer(zichtbaar);
  };

  markeer(index) {
    this.huidig = index;

    this.slides.forEach((slide, nummer) => {
      const zichtbaar = nummer === index;
      const pillen = slide.querySelector('.y-offer__pills');
      if (!pillen) return;

      /*
        aria-hidden mag alleen op iets waar je ook niet meer in kunt tabben —
        anders kan de aandacht in iets belanden dat voor een schermlezer niet
        bestaat. Daarom altijd allebei zetten, nooit één van de twee.
      */
      pillen.setAttribute('aria-hidden', zichtbaar ? 'false' : 'true');
      pillen.querySelectorAll('.y-offer__pill').forEach((pil) => {
        pil.tabIndex = zichtbaar ? 0 : -1;
      });
    });
  }
}

if (!customElements.get('yurls-offer')) {
  customElements.define('yurls-offer', YurlsOffer);
}